module.exports = "/src/views/donate/main/elements/shop/img/p_2.svg";